import React from 'react'

import styles from './style.module.css'
import { TxRow } from './types'

interface Props {
    rows: TxRow[]
}

function TxRows({ rows }: Props) {
    const filteredRows = rows?.filter(({ text }) => !!text)

    if (!filteredRows?.length) {
        return null
    }

    return (
        <div data-pointer="details_block" className={styles.list}>
            {filteredRows.map((item, index) => (
                <div className={styles.row} data-pointer={`details_row_${index}`} key={index}>
                    <div className={styles.mainContent}>
                        <span className={styles.title}>{item.title}</span>
                        <span className={styles.text}>{item.text}</span>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default TxRows
